export { default as LogInPage} from './page'


// WEBPACK FOOTER //
// ./src/pages/login/index.js